import React from 'react';

import CoffeeCup from 'components/icons/coffee-cup-filled';

interface IIcon {
  width?: number;
}

const Icon = ({ width }: IIcon) => {
  const s = width || 120;
  return <CoffeeCup width={s} height={s} />;
};

export default Icon;
